import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fieldset, Input, UniversalSelect } from '@feathr/components';
import { flattenError } from '@feathr/hooks';

import type {
  IEmailFieldSlice,
  IExportNameFieldSlice,
  ISharedFormSlice,
} from '../GroupExportModal.types';
import type { IGroupExportTypeOption } from '../GroupExportModal.utils';

export interface IExportTypeSection {
  exportTypeOptions: IGroupExportTypeOption[];
  selectedExportTypeOption: IGroupExportTypeOption | undefined;
  handleChangeExportType: (option: IGroupExportTypeOption) => void;
}

export interface IExportDetailsStepState
  extends ISharedFormSlice,
    IEmailFieldSlice,
    IExportNameFieldSlice,
    IExportTypeSection {}

export interface IExportDetailsStepProps {
  state: IExportDetailsStepState;
}

function ExportDetailsStep({ state }: Readonly<IExportDetailsStepProps>): JSX.Element {
  const { t } = useTranslation();

  const {
    exportTypeOptions,
    selectedExportTypeOption,
    handleChangeExportType,
    exportName,
    exportNameHadFocus,
    exportNameError,
    handleChangeExportName,
    handleExportNameBlur,
    email,
    emailHadFocus,
    emailError,
    handleChangeEmail,
    handleEmailBlur,
  } = state;

  return (
    <Fieldset>
      <UniversalSelect<IGroupExportTypeOption>
        label={t('Export type')}
        menuPortalTarget={document.body}
        name={'group-export-type'}
        onSelectSingle={handleChangeExportType}
        options={exportTypeOptions}
        value={selectedExportTypeOption}
      />
      <Input
        isClearable={true}
        label={t('Export name')}
        onBlur={handleExportNameBlur}
        onChange={handleChangeExportName}
        type={'text'}
        validationError={exportNameHadFocus ? flattenError(exportNameError) : undefined}
        value={exportName}
      />
      <Input
        helpText={t('If you want to send the report to a different email address.')}
        isClearable={true}
        label={t('Email address')}
        onBlur={handleEmailBlur}
        onChange={handleChangeEmail}
        type={'text'}
        validationError={emailHadFocus ? flattenError(emailError) : undefined}
        value={email}
      />
    </Fieldset>
  );
}

export default ExportDetailsStep;
